export const itemImages = {
  // Rods
  'Vara de Junco': '/images/rods/Icon37.png',
  'Vara do Lago Sereno': '/images/rods/icon_3_61.png',
  'Vara do Pescador Noturno': '/images/rods/icon_3_62.png',
  'Vara do Rio Selvagem': '/images/rods/icon_3_63.png',
  'Vara do Oceano Profundo': '/images/rods/icon_3_64.png',
  'Vara da Maré Alta': '/images/rods/icon_3_65.png',
  'Vara do Guardião das Águas': '/images/rods/icon_3_66.png',
  'Vara da Tempestade': '/images/rods/icon_3_67.png',
  'Vara do Leviatã': '/images/rods/icon_3_68.png',
  'Vara do Pescador Fantasma': '/images/rods/Icon38.png',
  'Vara de Cristal': '/images/rods/icon_3_61.png',
  'Vara do Horizonte': '/images/rods/Icon39.png',
  'Vara do Tritão': '/images/rods/Icon40.png',
  'Vara da Eternidade': '/images/rods/icon_3_69.png',
  'Vara do Destino': '/images/rods/icon_3_70.png',
  
  // Boats
  'Canoa de Madeira': '/images/boats/wooden-canoe.png',
  'Pequena Eva': '/images/boats/beach-boat.png',
  'Pescador Solitário': '/images/boats/lake-boat.png',
  'Mauá': '/images/boats/amazon-river-boat.png',
  'Navio Marianas': '/images/boats/ocean-fishing-ship.png',
  'Vasco da Gama': '/images/boats/crab-fishing-boat.png',
  'Puro luxo': '/images/boats/luxury-yacht.png',
  
  // Baits
  'Minhoca': '/images/baits/worm.png',
  'Grilo': '/images/baits/cricket.png',
  'Camarão': '/images/baits/shrimp.png',
  'I.S.C.A 3000': '/images/baits/ISCA3000.png',

  // Houses - Update existing house entries
  'Casinha de madeira': '/images/houses/wooden-house.png',
  'Casa arrumadinha': '/images/houses/organized-house.png',
  'Vila dos pescadores': '/images/houses/fisherman-village.png',
  'Hotel Belas Flores': '/images/houses/flowers-hotel.png',
  'Casa no penhasco': '/images/houses/cliff-house.png',
  'Mansão Magnata do Peixe': '/images/houses/fish-magnate-mansion.png',

  // Premium Items
  'Tônico Revitalizante': '/images/premiumItems/tonic/energyTonic.png',
  'Tônico da Sabedoria': '/images/premiumItems/tonic/experienceTonic.png',
  'Tônico do Mestre Pescador': '/images/premiumItems/tonic/forceTonic.png',
  'Tônico de Midas': '/images/premiumItems/tonic/goldTonic.png',
  '1 mês de Frezzer Industrial': '/images/premiumItems/refrigerator.webp',
  '6 meses de Frezzer Industrial': '/images/premiumItems/refrigerator.webp',
  '12 meses de Frezzer Industrial': '/images/premiumItems/refrigerator.webp',
  '1 mês Revitalizator 3000': '/images/premiumItems/luxuryHotel.webp',
  '3 meses Revitalizator 3000': '/images/premiumItems/luxuryHotel.webp',
  '6 meses Revitalizator 3000': '/images/premiumItems/luxuryHotel.webp',
  '12 meses Revitalizator 3000': '/images/premiumItems/luxuryHotel.webp',
  'Baú de madeira': '/images/chests/Icon2.png',
  'Caixote de Aço': '/images/chests/Icon6.png',
  'Baú Naúfragado': '/images/chests/Icon12.png',
  'Baú Kraken': '/images/chests/Icon22.png',
  'Baú de Poseidon': '/images/chests/Icon24.png',
  '5 tickets': '/images/premiumItems/ticket.png',
  '10 tickets': '/images/premiumItems/ticket.png',
  '25 tickets': '/images/premiumItems/ticket.png',
  'Pacote do jovem pescador': '/images/premiumItems/initial-package.webp',

  'Pier': '/images/maps/pier.png',
  'Praia': '/images/maps/beach.png',
  'Lago': '/images/maps/lake.png',
  'Rio Amazonas': '/images/maps/amazon.png',
  'Mar Aberto': '/images/maps/openSea.png',
  'Ilhas Cazu': '/images/maps/ilhasCazu.jpg',
  'Costa Dourada': '/images/maps/goldenCoast.jpg',
  
  // Default fallback image
  'default': '/default-item.svg'
};

export const getItemImage = (itemName) => {
  return itemImages[itemName] || itemImages.default;
};
